import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = {
  fill: "currentColor",
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 200 200",
  style: {"width":"100%","height":"100%"}
}
const _hoisted_2 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 2c37.9 0 68.6 24.3 68.6 62.5v.7c0 1-.1 2-.5 3s-.9 1.8-1.6 2.5c-.7.7-1.6 1.3-2.5 1.7s-2 .6-3 .6-2-.2-3-.6c-.9-.4-1.8-1-2.5-1.7s-1.3-1.6-1.6-2.5c-.4-1-.5-2-.5-3v-2.6c-.5-29.6-24.8-46.7-54.2-46.2-29.4.5-52.9 18.4-52.4 48V82h129.6c4 0 7.9 1.7 10.8 4.5 2.8 2.9 4.4 6.8 4.4 10.8v85.4c0 4.1-1.6 7.9-4.4 10.8-2.9 2.9-6.7 4.5-10.8 4.5H23.8c-4.1 0-7.9-1.6-10.8-4.5-2.9-2.9-4.5-6.8-4.4-10.8V97.3c0-4.1 1.6-7.9 4.4-10.8 2.9-2.9 6.7-4.5 10.8-4.5h7.6V64.5C31.4 27.1 60.9 3.1 98 2h2zm76.2 95.3H23.8v85.4h152.4V97.3z"
}, null, -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("path", {
  fill: "currentColor",
  d: "M100 152.3c7.2 0 13.1-5.8 13.1-13.1 0-7.2-5.8-13.1-13.1-13.1s-13.1 5.8-13.1 13.1c0 7.2 5.9 13.1 13.1 13.1z"
}, null, -1)
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", {
    class: "tri-icon",
    style: _normalizeStyle(`font-size: ${_ctx.size}; color: ${_ctx.color}; width: 1em; height: 1em; display:block; line-height: 0;`)
  }, [
    (_openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_4))
  ], 4))
}